export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  blockTitleMaxChar: 8,
  blockSubTitleMaxChar: 100,
  blockParagraphMaxChar: 1000,
  featureBlocks: {
    min: 1,
    max: 12
  }
}